import { top20Filters } from './constants'

// eslint-disable-next-line import/prefer-default-export
export function cityIdExistsInTop20Filters(
  cityId: string | undefined
): cityId is keyof typeof top20Filters {
  return cityId !== undefined && cityId in top20Filters
}
